"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MessageEvent = exports.HandleFrameMessageResp = exports.HandleType = void 0;
var ExtLogger_1 = __importDefault(require("./ExtLogger"));
var ExtApiAuth_1 = __importDefault(require("../ext/ExtApiAuth"));
var ExtEndpointModulesManager_1 = __importDefault(require("../ext/ExtEndpointModulesManager"));
var ExtFunctionalProvider_1 = __importDefault(require("./ExtFunctionalProvider"));
var HandleType;
(function (HandleType) {
    HandleType[HandleType["RESPONSABLE"] = 0] = "RESPONSABLE";
    HandleType[HandleType["SILENT"] = 1] = "SILENT";
})(HandleType = exports.HandleType || (exports.HandleType = {}));
var HandleFrameMessageResp = /** @class */ (function () {
    function HandleFrameMessageResp() {
    }
    return HandleFrameMessageResp;
}());
exports.HandleFrameMessageResp = HandleFrameMessageResp;
var MessageEvent;
(function (MessageEvent) {
    MessageEvent["TEXT_NOTICE"] = "ext_component_text_notice";
    MessageEvent["STATUS_NOTICE"] = "ext_component_status_notice";
    MessageEvent["EXT_CLOSE"] = "ext_close";
})(MessageEvent = exports.MessageEvent || (exports.MessageEvent = {}));
/**
 * 小程序中台适配器
 */
var ExtAdapter = /** @class */ (function () {
    function ExtAdapter() {
        var _this = this;
        this.extEndpointModulesManager = new ExtEndpointModulesManager_1["default"](this);
        this.extApiAuth = new ExtApiAuth_1["default"](this.getFuncMap());
        this.logger = ExtLogger_1["default"].getGlobalLogger(function (logContent) { return _this.log(logContent); });
    }
    /**
     * 获取SDK功能模块
     * @param extMain 小程序主体信息
     * @param extComEndpoint 小程序endpoint信息
     * @param modalContainer 弹窗容器
     */
    ExtAdapter.prototype.getFunctionalProvider = function (extMain, extComEndpoint, modalContainer) {
        return ExtFunctionalProvider_1["default"].getSharedInstance(this.logger, extMain, extComEndpoint, modalContainer);
    };
    /**
     * 获取权限 - 方法名映射表
     */
    ExtAdapter.prototype.getFuncMap = function () {
        return {};
    };
    return ExtAdapter;
}());
exports["default"] = ExtAdapter;
